// The faces the templates draw with. The old server-rendered templates set
// their lyrics and labels in a geometric sans (Outfit is the match) and
// Neon's word in a chunky display face (Bungee). Canvas only draws a web
// font once it has loaded, so the studio waits on ensureFonts() before the
// first frame, and the export draws with exactly what the preview did.

export const SANS = '"Outfit", "Arial", sans-serif';
export const DISPLAY = '"Bungee", "Arial Black", sans-serif';

const CSS =
  "https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700;800&family=Bungee&display=block";
let ready: Promise<void> | null = null;

export function ensureFonts(): Promise<void> {
  if (typeof document === "undefined") return Promise.resolve();
  if (ready) return ready;
  ready = (async () => {
    if (!document.getElementById("videostudio-fonts")) {
      const link = document.createElement("link");
      link.id = "videostudio-fonts";
      link.rel = "stylesheet";
      link.href = CSS;
      document.head.appendChild(link);
      await new Promise<void>((settle) => {
        link.onload = () => settle();
        link.onerror = () => settle();
      });
    }
    await Promise.all(
      [
        "400 40px Outfit",
        "600 40px Outfit",
        "700 40px Outfit",
        "800 40px Outfit",
        "400 40px Bungee",
      ].map((spec) => document.fonts.load(spec).catch(() => undefined)),
    );
  })();
  return ready;
}
